(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("dashboardResource", ["$resource", dashboardResource]);
    function dashboardResource($resource) {
        return $resource("/api/dashboard/:personSeq/:action", { personSeq: "@personSeq", action: "@action" }, {
            getAdminViewModel: {
                method: "GET",
                params: { action: "adminView" }
            },
            getBadgesViewModel: {
                method: "GET",
                params: { action: "badges" }
            },
            getCertificatesViewModel: {
                method: "GET",
                params: { action: "certificates" }
            },
            getCECreditsView: {
                method: "GET",
                params: { action: "cecredits" }
            },
            getCommonViewModel: {
                method: "GET",
                params: { action: "common" }
            },
            getGamificationViewModel: {
                method: "GET",
                params: { action: "gamification" }
            },
            getHomePageViewModel: {
                method: "GET",
                params: { action: "homePage" }
            },
            getLearningViewModel: {
                method: "GET",
                params: { action: "learning" }
            },
            getLeaderboardViewModel: {
                method: "GET",
                params: { action: "leaderboard" }
            },
            getSuperAdminViewModel: {
                method: "GET",
                params: { action: "superAdminView" }
            }
        });
    }
    ;
}());
